$(document).ready(function(){
    App.vue.init();

    require('./love-you/app');
});